var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseHeading',{staticClass:"mb-3 properties-heading",attrs:{"tag":"h4"}},[_vm._v(" Properties ")]),(_vm.isSectionSelected)?_c('SectionProperties'):_vm._e(),(_vm.isFieldSelected)?_c('FieldProperties'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }